import React, { useState, useEffect, useRef } from "react";
import { Table, Button, Input, Space, Card, Select, Pagination, Form, Row, Col } from 'antd';
// import DatePicker from 'react-datepicker2'; // Import Persian DatePicker
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import strings from '../../utils/strings';
import moment from 'moment-jalaali';
import { useNavigate } from 'react-router-dom';
import Highlighter from "react-highlight-words";
import { SearchOutlined, ZoomInOutlined } from "@ant-design/icons";
import InsuranceDetails from "../shared/insuranceDetails/InsuranceDetails";
import XLSX from 'xlsx'
import { usePersistedStore } from "../../store/persisted-store";
import { useGeneralStore } from "../../store/slices/createGeneralSlice";
import { useReportsStore } from "../../store/slices/createReportsSlice";
import axiosInstance from "../../axios";
import config from "../../config";
import ValidatorHelper from "../helpers/ValidatorHelper";


export default function BusinessRejectedReport() {

    const reports = useReportsStore()
    const general = useGeneralStore();
    const navigate = useNavigate();
    const { auth, business } = usePersistedStore();
    const userInfoResources = auth.userInfo.Resources;
    const data = reports.rejected.data.Items;
    const total = reports.rejected.data.Total;
    const loading = reports.rejected.loading;
    const [searchText, setSearchText] = useState("");
    const currentBusiness = business.currentBusiness;

    const [searchedColumn, setSearchedColumn] = useState("");
    const [requestId, setRequestId] = useState();
    const { token } = currentBusiness;
    const [reasons, setReasons] = useState([]);
    const firstCall = useRef(true)    // New state for filters
    const [selectedReason, setSelectedReason] = useState(null);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [page, setPage] = useState(1);
    const pageSize = 10;

    useEffect(() => {
        getReasons();
    }, []);

    useEffect(() => {
        if (firstCall.current || token) {
            reports.getRejectedInfo({
                FromDate: fromDate ? moment(fromDate).format('YYYY/MM/DD') : moment().format('YYYY/MM/DD'),
                ToDate: toDate ? moment(toDate).format('YYYY/MM/DD') : moment().format('YYYY/MM/DD'),
                ReasonId: selectedReason && selectedReason,
                PageSize: pageSize,
                PageNumber: 1
            });
            setPage(1);
            firstCall.current = false;
        }
    }, [token])

    useEffect(() => {
        if (!token)
            navigate('/dashboard');
    }, [navigate, token])

    async function getReasons() {
        try {
            const url = `/v1/business/Reason`;
            const resp = await axiosInstance({
                method: "get",
                baseURL: config.apiUrls(),
                url: url,
            });

            // Check if resp.data is an array, if not, handle accordingly
            if (Array.isArray(resp.data)) {
                setReasons(resp.data);
            } else if (resp.data && typeof resp.data === 'object') {
                // If it's an object with items property
                if (Array.isArray(resp.data.Items)) {
                    setReasons(resp.data.Items);
                } else {
                    // Convert object to array if needed
                    const reasonsArray = Object.values(resp.data);
                    setReasons(reasonsArray);
                }
            } else {
                console.error("Unexpected reasons data format:", resp.data);
                setReasons([]);
            }
        } catch (error) {
            console.log(error);
            setReasons([]);
        }
    }

    function convertToMoment(date) {
        return moment(date?.toDate()).format("YYYY-MM-DD");
    }

    function onFinish(values) {
        const params = {
            FromDate: convertToMoment(fromDate),
            ToDate: convertToMoment(toDate),
            ReasonId: values.selectedReason,
            PageSize: pageSize,
            PageNumber: 1,
        }

        reports.getRejectedInfo(params);
        setFromDate(values.fromDate);
        setToDate(values.toDate);
        setSelectedReason(values.selectedReason);
        setPage(1);
    }


    const pageChange = (page, pageSize) => {

        setPage(page)
        reports.getRejectedInfo({
            FromDate: convertToMoment(fromDate),
            ToDate: convertToMoment(toDate),
            ReasonId: selectedReason && selectedReason,
            PageSize: pageSize,
            PageNumber: page
        });

    }
    let searchInput;
    const getColumnSearchProps = (dataIndex, title) => ({
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
        }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={(node) => {
                        searchInput = node;
                    }}
                    placeholder={`جستجو ${title}`}
                    value={selectedKeys[0]}
                    onChange={(e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: "block" }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        جستجو
                    </Button>
                    <Button
                        onClick={() => handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        ریست
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase())
                : "",
        onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ""}
                />
            ) : (
                text
            ),
    });
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText("");
    };

    const columns = [{
        title: "جزئیات بیمه نامه",
        dataIndex: "operation",
        key: "operation",
        width: 85,
        render: (_, record) =>
            data && data.length >= 1 && (
                <Space size="middle">
                    <Button type='link' onClick={() => {
                        reports.getInsuranceDetailsInfo(record.RequestId)
                        setRequestId(record.RequestId);
                        general.ToggleInsuranceDetailsModal();
                    }
                    }><ZoomInOutlined /></Button>
                </Space>
            )
    },

    {
        title: "نام بیمه گزار",
        dataIndex: "PersonName",
        key: "PersonName",
        width: 120,
        sorter: (a, b) => {
            let first = "";
            let second = "";
            a.PersonName ? (first = a.PersonName) : (first = "");
            b.PersonName ? (second = b.PersonName) : (second = "");
            return first.localeCompare(second);
        },
        ...getColumnSearchProps("PersonName", "نام بیمه گزار"),
        render: text => <span style={{ color: '#5ec393' }}>{text}</span>,
    },
    {
        title: "نام کاربری",
        dataIndex: "UserName",
        key: "UserName",
        width: 120,
        sorter: (a, b) => {
            let first = "";
            let second = "";
            a.UserName ? (first = a.UserName) : (first = "");
            b.UserName ? (second = b.UserName) : (second = "");
            return first.localeCompare(second);
        },
        ...getColumnSearchProps("UserName", "نام کاربری"),

    },
    {
        title: "رشته",
        dataIndex: "BranchName",
        key: "BranchName",
        width: 100,
    }, {
        title: "دلیل رد درخواست",
        dataIndex: "ReasonTitle",
        key: "ReasonTitle",
        width: 110,
    },
    {
        title: "مبلغ پرداختی",
        dataIndex: "Payment",
        key: "Payment",
        width: 100,
        render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
        title: "مبلغ کل",
        dataIndex: "SummarizeAmount",
        key: "SummarizeAmount",
        width: 110,
        render: data => data && strings.currencyFormat(data) + ' ریال',
    },

    {
        title: "مدت بیمه نامه",
        dataIndex: "DurationTitle",
        key: "DurationTitle",
        width: 100,
    },
    {
        title: "شرکت بیمه",
        dataIndex: "CompanyName",
        key: "CompanyName",
        width: 100,
    },
    {
        title: "تخفیف",
        dataIndex: "VoucherAmount",
        key: "VoucherAmount",
        width: 100,
        render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
        title: "جریمه",
        dataIndex: "Penalty",
        key: "Penalty",
        width: 100,
        render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
        title: "روش پرداخت",
        dataIndex: "Installment",
        key: "Installment",
        width: 80,
        render: data => data ? 'اقساطی' : 'نقدی'
    },
    {
        title: "کد رهگیری",
        dataIndex: "TrackingCode",
        key: "TrackingCode",
        width: 115,
        sorter: (a, b) => a.TrackingCode.localeCompare(b.TrackingCode),
        ...getColumnSearchProps('TrackingCode', 'کد رهگیری'),
        render: text => text && text.toUpperCase().replace('BM-', '')
    },
    {
        title: "کد درخواست",
        dataIndex: "RequestId",
        key: "RequestId",
        ellipsis: true,
        width: 100,
        ...getColumnSearchProps('RequestId', 'کد درخواست'),
        render: data => data && strings.getFarsiNum(data),
    },
    {
        title: "تاریخ خرید",
        dataIndex: "BuyDate",
        key: "BuyDate",
        width: 110,
        sorter: (a, b) => {
            let first = '';
            let second = '';
            a.BuyDate ? first = a.BuyDate : first = '';
            b.BuyDate ? second = b.BuyDate : second = '';
            return first.localeCompare(second)
        },
        render: data => data && (data.BuyDate === null ? "" : strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD')))
    }
    ];

    // useEffect(() => {
    //     if (!token)
    //         navigate('/dashboard');
    //     reports.getRejectedInfo();
    // }, [navigate, token])


    function downloadxlsx() {
        if (!data) return
        let xlsxData = data.map(d => [
            d.PersonName,
            d.UserName,
            d.BranchName,
            d.Payment,
            d.SummarizeAmount,
            d.DurationTitle,
            d.CompanyName,
            d.VoucherAmount,
            d.Penalty,
            d.Installment === true ? 'اقساطی' : 'نقدی',
            d.TrackingCode,
            d.RequestId,
            moment(d.BuyDate).format('jYYYY/jMM/jDD')
        ])
        xlsxData.unshift(['نام بیمه گزار', ' نام کاربری', 'رشته', ' مبلغ پرداختی', ' مبلغ کل', 'مدت بیمه نامه', 'شرکت بیمه', 'تخفیف', 'جریمه', 'روش پرداخت', 'کد رهگیری', 'کد درخواست', 'تاریخ خرید'])
        const worksheet = XLSX.utils.aoa_to_sheet(xlsxData);
        const new_workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(new_workbook, worksheet, "SheetJS");
        XLSX.writeFile(new_workbook, "bimeh[dot]com.xlsx")
    }

    const layout = {
        lg: 6,
        md: 12,
        xs: 24
    }

    const btnLayout = {
        lg: 6,
        md: 12,
        xs: 24
    }
    return (
        <Card>
            <Form
                className="sale-filter"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                onFinish={onFinish}
                initialValues={{
                    fromDate: fromDate && fromDate || moment(),
                    toDate: toDate && toDate || moment()
                }}
            >

                <Row gutter={[8]}>
                    <Col {...layout}>
                        <Form.Item
                            name='selectedReason'
                            label='دلیل رد:'>
                            {reasons ? <Select
                                placeholder="انتخاب دلیل رد"
                                style={{ width: '100%' }}
                                defaultValue={null}
                                onChange={(value) => setSelectedReason(value)}
                                allowClear
                            >
                                <Select.Option key={null} value={null}>
                                    همه
                                </Select.Option>
                                {Array.isArray(reasons) && reasons.map(reason => (
                                    <Select.Option key={reason.Id} value={reason.Id}>
                                        {reason.Title}
                                    </Select.Option>
                                ))}
                            </Select> : ""}
                        </Form.Item>
                    </Col>
                    <Col {...layout}>
                        <Form.Item
                            name='fromDate'
                            label='از تاریخ'
                            rules={ValidatorHelper.required('تاریخ')}>
                            <DatePicker
                                value={fromDate}
                                onChange={setFromDate}
                                calendar={persian}
                                locale={persian_fa}
                                format="YYYY/MM/DD"
                                inputClass="datepicker-input"
                                calendarPosition="bottom-right"
                                portal
                                zIndex={1070}
                            />
                        </Form.Item>
                    </Col>
                    <Col {...layout}>
                        <Form.Item
                            name='toDate'
                            label='تا تاریخ'
                            rules={ValidatorHelper.required('تاریخ')}>
                            <DatePicker
                                value={toDate}
                                onChange={setToDate}
                                calendar={persian}
                                locale={persian_fa}
                                format="YYYY/MM/DD"
                                inputClass="datepicker-input"
                                calendarPosition="bottom-right"
                                portal
                                zIndex={1070}
                            />
                        </Form.Item>
                    </Col>
                    <Col {...btnLayout}>
                        <Form.Item label=" " colon={false}>
                            <button
                                disabled={loading} type="primary" className="btn btn-primary waves-effect waves-light" htmltype="submit">
                                جستجو&nbsp;&nbsp;&nbsp; <i className={loading ? "bx bx-loader bx-spin" : "fas fa-search"}></i>
                            </button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
            {data?.length > 0 ? <button type="primary" className="btn btn-success waves-effect waves-light float-left" style={{ marginLeft: "10px" }}
                onClick={downloadxlsx} >
                دریافت اکسل&nbsp;&nbsp;&nbsp;<i className="far fa-file-excel font-size-14 align-middle mr-2"></i>
            </button> : ""}
            <Table
                style={{ overflowX: 'scroll' }}
                className="custom-table"
                size="small"
                bordered
                loading={loading}
                rowKey="RequestId"
                dataSource={data}
                scroll={true}
                columns={userInfoResources &&
                    (userInfoResources.includes("BusinessSaleReport") ||
                        userInfoResources.includes("BusinessSupportReport")) ?
                    columns : (columns.filter(col => col.dataIndex !== 'operation'))}
                pagination={false}
            />
            {data && data.length > 0 && <Pagination
                defaultCurrent={1}
                current={page}
                onChange={pageChange}
                pageSize={pageSize}
                total={total}
                showSizeChanger={false} />}
            <InsuranceDetails requestId={requestId} />
        </Card>
    );
}